import { axiosPrivate } from "../axios-config/axiosPrivate";
import { BACKEND } from "../config/backend";

export const getArtistLocations = async (artistId) => {
    const response = await axiosPrivate.get(`${BACKEND}/api/v1/artists/${artistId}/locations`);
    return response.data;
};

export const insertArtistLocation = async ({ artistLocation }) => {
    const response = await axiosPrivate.post(
        `${BACKEND}/api/v1/artists/${artistLocation.ArtistID}/locations`,
        artistLocation
    );
    return response.data;
};

export const updateArtistLocation = async ({ artistLocation }) => {
    const response = await axiosPrivate.put(
        `${BACKEND}/api/v1/artists/${artistLocation.ArtistID}/locations`,
        artistLocation
    );
    return response.data;
};

export const deleteArtistLocation = async ({ artistLocation }) => {
    const response = await axiosPrivate.delete(
        `${BACKEND}/api/v1/artists/${artistLocation.ArtistID}/locations/${artistLocation.ArtAtOrtID}`
    );
    return response.data;
};


